import React from "react";
import LandingPageSection from "./LandingPageSection";
import FeatureContentType from "./FeatureContentType";
import CardGrid from "../ResourceTileComponents/CardGrid";

interface Props {
  landingPageSections: LandingPageSection[];
}

const FoodServiceResourcesHomepage = ({ landingPageSections }: Props) => (
  <div
    data-module="foodServiceResourcesIndex"
    className="pt-4 px-4 xs:px-0 xs:pt-0"
  >
    {landingPageSections.map((section) => {
      const showHeroCard =
        section.sortOrder === -1 ||
        section.featureContentType !== FeatureContentType.None;

      return (
        <div className={section.className} key={section.id}>
          <h2 className="fsr-section-header">
            {section.title}
            {section.title
              .toLowerCase()
              .includes("recently published") ? null : (
              <a href={section.link} className="view-all">
                View {section.sortOrder === 0 ? "Blogs" : "More"}
              </a>
            )}
          </h2>
          <div className="fsr-flex">
            <CardGrid
              resources={section.resources}
              hasRecentPosts={showHeroCard}
              sliceCount={showHeroCard ? 5 : 6}
              startSliceIndex={0}
            />
          </div>
        </div>
      );
    })}
  </div>
);

export default FoodServiceResourcesHomepage;
